import React from "react";
import "../../components/Blog/BlogDetails.css";

const BlogDetails = () => {
	return (
		<div className=" font-poppins ">
			<div className="blog-details-top">
				<h2 className="blog-details-title custom-inner-space custom-container-upper">News</h2>

				<div className="blog-details-main custom-inner-space ">
					<div className="blog-details-featured">
						<img
							src="https://via.placeholder.com/500x300"
							alt="Main Blog"
							className="blog-details-featured-img"
						/>
						<h3 className="blog-details-featured-heading">Lorem ipsum</h3>
						<p className="blog-details-featured-desc">
							Lorem ipsum dolor sit amet consectetur. Et nunc viverra tempus leo mauris
							diam tellus donec. Lorem ipsum dolor sit amet consectetur.
						</p>
					</div>

					<div className="blog-details-recent-news">
						<div className="blog-details-recent-header">
							<h4>Recent News</h4>
							<span className="blog-details-arrow">›</span>
						</div>

						{[1, 2, 3].map((item, index) => (
							<div className="blog-details-recent-item" key={index}>
								<img
									src={`https://via.placeholder.com/100x80?text=Img+${item}`}
									alt="Recent"
									className="blog-details-recent-img"
								/>
								<div className="blog-details-recent-text">
									<h5>Lorem ipsum</h5>
									<p>
										Lorem ipsum dolor sit amet consectetur. Et nunc viverra tempus leo mauris diam
										tellus donec.
									</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="blog-details-posts-wrapper">
				<h2 className="blog-details-posts-title custom-inner-space custom-container-upper">Latest posts</h2>

				<div className="blog-details-posts-container custom-inner-space">
					<div className="blog-details-posts-main">
						<div className="blog-details-posts-main-img-wrapper">
							<img
								src="https://via.placeholder.com/500x280"
								alt="Post"
								className="blog-details-posts-main-img"
							/>
						</div>
						<h3 className="blog-details-posts-main-heading">Lorem ipsum</h3>
						<p className="blog-details-posts-main-desc">
							Lorem ipsum dolor sit amet consectetur. Et nunc viverra tempus leo mauris diam tellus
							donec. Lorem ipsum dolor sit amet consectetur. Lorem ipsum dolor sit amet consectetur. Et
							nunc viverra tempus leo mauris diam tellus donec. Lorem ipsum dolor sit amet consectetur.
						</p>
						<button className="blog-details-posts-read-btn">Read More</button>
					</div>

					<div className="blog-details-posts-side">
						{[1, 2].map((item, index) => (
							<div className="blog-details-posts-side-item" key={index}>
								<img
									src={`https://via.placeholder.com/120x80?text=Img+${item}`}
									alt={`Post ${item}`}
									className="blog-details-posts-side-img"
								/>
								<p className="blog-details-posts-side-desc">
									Lorem ipsum dolor sit amet consectetur. Et nunc viverra tempus leo mauris diam tellus
									donec.
								</p>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="blog-latest-posts-grid-section">
				<h2 className="blog-latest-posts-title ">Latest posts</h2>
				<p className="blog-latest-posts-subtitle ">
					Lorem ipsum dolor sit amet consectetur. Et nunc viverra tempus leo mauris diam tellus donec.
				</p>

				<div className="blog-latest-posts-grid custom-inner-space ">
					{[1, 2, 3, 4, 5, 6].map((item, index) => (
						<div className="blog-latest-post-card" key={index}>
							<div className="blog-latest-post-image-wrapper">
								<img
									src={`https://via.placeholder.com/300x200?text=Img+${item}`}
									alt={`Post ${item}`}
									className="blog-latest-post-image"
								/>
								<div className="blog-latest-post-overlay">
									<p className="blog-latest-post-text">Lorem ipsum dolor sit amet consectetur.</p>
								</div>
							</div>
						</div>
					))}
				</div>

				{/* Pagination */}
				<div className="blog-latest-posts-pagination">
					<button className="pagination-arrow">‹</button>
					<span className="pagination-page">1/3</span>
					<button className="pagination-arrow">›</button>
				</div>
			</div>

		</div>
	);
};

export default BlogDetails;
